import Vue from 'vue';

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
	faUser,
	faLock,
	faBars,
	faChevronDown,
	faCaretDown,
	faChevronLeft,
	faChevronRight,
	faExclamationTriangle,
	faCheckSquare,
	faPencilAlt,
	faTrash,
	faSortUp,
	faSortDown,
	faPoll,
	faHome,
	faCalendar,
	faStickyNote,
	faSignOutAlt,
	faCog,
	faSave,
	faBan,
	faTimes,
	faEraser,
	faDollarSign,
	faCopy,
	faServer,
	faPaperclip,
	faPooStorm,
	faSyncAlt, faEye
} from '@fortawesome/free-solid-svg-icons';

import {
	faCircle,
	faClock,
	faDotCircle,
	faSquare
} from '@fortawesome/free-regular-svg-icons';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons/faTimesCircle';
import {faTwitch} from "@fortawesome/free-brands-svg-icons";

library.add(
	faUser,
	faLock,
	faBars,
	faChevronDown,
	faCaretDown,
	faChevronLeft,
	faChevronRight,
	faExclamationTriangle,
	faSquare,
	faCheckSquare,
	faPencilAlt,
	faTrash,
	faSortUp,
	faSortDown,
	faPoll,
	faHome,
	faStickyNote,
	faCalendar,
	faSignOutAlt,
	faClock,
	faCog,
	faSave,
	faBan,
	faCircle,
	faDotCircle,
	faTimes,
	faEraser,
	faDollarSign,
	faCopy,
	faServer,
	faPaperclip,
	faTimesCircle,
	faPooStorm,
	faSyncAlt,
	faTwitch
);

Vue.component('font-awesome-icon', FontAwesomeIcon);
